import CustomChip from "../../components/CustomChip";
import CustomSteteChip from "../../components/CustomStateChip";

export function getGridColumns() {
    return [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            editable: false,
        },
        {
            field: "title",
            headerName: "Title",
            flex: 1,
            editable: false,
            alignItems: "center",
            headerAlign: "center",
        },
        {
            field: "genrePath",
            headerName: "Genre",
            flex: 1,
            editable: false,
            alignItems: "center",
            headerAlign: "center",
        },
        {
            field: "state",
            headerName: "State",
            width: 130,
            editable: false,
            alignItems: "center",
            align: "center",
            renderCell: (params) => {
                if (params.value == undefined || params.value === "") {
                    return;
                }

                return <CustomSteteChip label={params.value} size="small" />;
            },
            headerAlign: "center",
        },
        {
            field: "free",
            headerName: "Free",
            width: 100,
            editable: false,
            alignItems: "center",
            align: "center",
            renderCell: (params) => {
                return <CustomChip freePaid value={params.value} size="small" />;
            },
            headerAlign: "center",
        },
        {
            field: "createdAt",
            headerName: "Created",
            flex: 0.5,
            editable: false,
            alignItems: "center",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "publishedAt",
            headerName: "Published",
            width: 120,
            editable: false,
            alignItems: "center",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "cloudUser.email",
            headerName: "Creator",
            flex: 1,
            editable: false,
            alignItems: "center",
            headerAlign: "center",
            align: "center",
        },
    ];
}

